import CustomTextField from "components/CustomTextField";
import {
  selectCurrentRoles,
  selectCurrentToken,
  selectCurrentUser,
} from "features/auth/authSlice";
import React, { useEffect } from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { CardHeader, Col, Input, Label, Row, Spinner } from "reactstrap";
import { useAllDropDownDataQuery } from "services/dropdownApiSlice";
import Select from "react-select";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { API_URL } from "app/config";

const SaathiBusinessDetails = ({ SaathiUserData, saathiDetailsRefetch }) => {
  const { id } = useParams();
  const [isEdit, setisEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const { handleSubmit, reset } = useForm();
  const user_token = useSelector(selectCurrentToken);
  const currentUser = useSelector(selectCurrentUser);
  const RolesFromToken = useSelector(selectCurrentRoles);

  const [IncomeSource, setIncomeSource] = useState([]);
  const [selectedincome, setSelectedIncome] = useState(null);

  const { data: dropdownitem } = useAllDropDownDataQuery();

  const IncomeOptions = () => {
    return dropdownitem?.data?.results[0]?.income_type?.map((item) => ({
      value: item,
      label: item,
    }));
  };

  const handleIncomeChange = (selectedOption) => {
    setIncomeSource(selectedOption);
    setSelectedIncome(selectedOption.value);
  };

  const [SaathiData, editSaathiData] = useState({
    source_of_income: "",
    income: "",
    experience_in_insurance: false,
    experience_in_banking: false,
    experience_in_agrani_input: false,
    experience_in_agrani_output: false,
    is_professional_training_insurance_and_bank_product: "false",
    interest_in_selling: "",
  });

  const [professionaltraining, setprofessionaltraining] = useState([]);
  function handelprofessionaltraining(professionaltraining) {
    setprofessionaltraining(professionaltraining);
  }
  // ExamStatusData selectbox
  const PlicyData = [
    {
      label: "Status",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  ];
  const onInputChange = (event) => {
    editSaathiData({
      ...SaathiData,
      [event.target.name]: event.target.value,
    });
  };

  const onSubmitSaathiData = (e) => {
    setLoader(true);
    var formData = new FormData();
    formData.append(
      "source_of_income",
      selectedincome || SaathiUserData?.business_details?.income_source
    );
    formData.append(
      "income",
      SaathiData.income || SaathiUserData?.business_details?.income
    );
    formData.append(
      "experience_in_insurance",
      SaathiUserData?.business_details?.experience_in_insurance ||
        SaathiData?.experience_in_insurance
    );
    formData.append(
      "experience_in_agrani_input",
      SaathiUserData?.business_details?.experience_in_agrani_input ||
        SaathiData?.experience_in_agrani_input
    );
    formData.append(
      "experience_in_banking",
      SaathiUserData?.experience_in_banking || SaathiData?.experience_in_banking
    );
    formData.append(
      "experience_in_agrani_output",
      SaathiData?.experience_in_banking ||
        SaathiUserData?.business_details?.experience_in_agrani_output
    );
    // formData.append(
    //   "is_professional_training_insurance_and_bank_product",
    //   professionaltraining
    // )
    formData.append(
      "interest_in_selling",
      SaathiData?.interest_in_selling ||
        SaathiUserData?.business_details?.interest_in_selling
    );
    formData.append("ui_section_id", "6");
    formData.append("created_by", currentUser.sub);
    formData.append("created_by_name", currentUser.name);
    formData.append("applicant_id", id);

    fetch(`${API_URL}/empanelment/api/business-details/`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Token ${user_token}` },
    }).then((resp) => {
      const result = resp;
      if (result.status === 200 || result.status === 201) {
        resp
          .json()
          .then((response) => {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.message,
              timer: 1500,
            });
            setLoader(false);
            setisEdit(false);
            saathiDetailsRefetch(id);
          })
          .catch((err) => console.log(err));
      } else {
        result
          .json()
          .then((response) => {
            swal("...Ooops", {
              buttons: false,
              icon: "warning",
              title: response.message,
              timer: 1500,
            });
            setLoader(false);
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 48,
    }),
  };
  useEffect(() => {
    if (SaathiUserData?.business_details) {
      editSaathiData({ ...SaathiUserData?.business_details });
    }
  }, [SaathiUserData?.business_details]);

  useEffect(() => {
    if (
      (SaathiUserData?.business_details?.experiences?.experience_fields || [])
        .length > 0
    ) {
      var experienceIn =
        SaathiUserData?.business_details?.experiences?.experience_fields;
      editSaathiData((prev) => {
        return {
          ...prev,
          experience_in_insurance: experienceIn.includes("1"),
          experience_in_banking: experienceIn.includes("2"),
          experience_in_agrani_input: experienceIn.includes("3"),
          experience_in_agrani_output: experienceIn.includes("4"),
        };
      });
    }
  }, [SaathiUserData?.business_details]);

  // console.log(SaathiData , "hehyyy")

  return (
    <Row>
      <CardHeader
        style={{ padding: "13px" }}
        className=" mb-3 d-flex justify-content-between align-items-center mt-3"
      >
        <h5 className="m-0">Bussiness Details </h5>

        {RolesFromToken.groups?.includes("Maker") ? (
          SaathiUserData?.onboarding_status === "QC1 Approved" ? (
            ""
          ) : (
            <div>
              {" "}
              {isEdit ? (
                <Button
                  size="sm"
                  id="editDetails"
                  type=""
                  className=" btn-danger waves-effect  "
                  onClick={() => setisEdit(false)}
                >
                  Cancel <i className="mdi mdi-window-close"></i>
                </Button>
              ) : (
                <Button
                  size="sm"
                  id="editDetails"
                  type=""
                  className="  waves-effect  "
                  onClick={() => setisEdit(true)}
                >
                  Edit <i className="mdi mdi-file-edit-outline"></i>
                </Button>
              )}
            </div>
          )
        ) : (
          ""
        )}
      </CardHeader>
      <form onSubmit={handleSubmit(onSubmitSaathiData)} className="p-2">
        <Row>
          {isEdit === true ? (
            <Col lg="3" className="mb-3">
              <Label>Source of income</Label>
              <Select
                value={IncomeSource}
                onChange={(e) => handleIncomeChange(e)}
                options={IncomeOptions()}
                styles={customStyles}
                placeholder={
                  SaathiUserData?.business_details?.income_source ||
                  "Select Source"
                }
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-3">
              <Label>Source of income</Label>
              <Input
                type="text"
                name=""
                defaultValue={SaathiUserData?.business_details?.income_source}
                disabled
                className="input_text"
              />
            </Col>
          )}
          <Col lg="3" className="mb-2">
            <Label>Anual Income</Label>
            <Input
              type="number"
              name="income"
              defaultValue={SaathiUserData?.business_details?.income}
              disabled={isEdit === true ? false : true}
              onChange={onInputChange}
              placeholder="Enter Anual Income"
              className="input_text"
            />
          </Col>
          {isEdit === true ? (
            <Col lg="6" className="mb-2">
              <Label>Experience in :</Label>
              <div className="d-flex form-check text_box ps-0 ">
                <div className="form-check me-3 ps-0">
                  <input
                    onChange={onInputChange}
                    className="form-check-Input"
                    type="checkbox"
                    name="experience_in_insurance"
                    id="ExperienceinInsurance"
                    checked={SaathiData?.experience_in_insurance}
                  />
                  <Label className="form-check-Label ms-2" htmlFor="Yes">
                    Insurance
                  </Label>
                </div>

                <div className="form-check me-3">
                  <input
                    onChange={onInputChange}
                    className="form-check-Input"
                    type="checkbox"
                    name="experience_in_banking"
                    checked={SaathiData?.experience_in_banking}
                  />
                  <Label className="form-check-Label  ms-2" htmlFor="Yes">
                    Banking
                  </Label>
                </div>

                <div className="form-check me-3">
                  <input
                    onChange={onInputChange}
                    className="form-check-Input"
                    type="checkbox"
                    name="experience_in_agrani_input"
                    checked={SaathiData?.experience_in_agrani_input}
                  />

                  <Label className="form-check-Label  ms-2" htmlFor="Yes">
                    Agri Input
                  </Label>
                </div>

                <div className="form-check me-3">
                  <input
                    onChange={onInputChange}
                    className="form-check-Input"
                    type="checkbox"
                    name="experience_in_agrani_output"
                    checked={SaathiData?.experience_in_agrani_output}
                  />
                  <Label className="form-check-Label  ms-2" htmlFor="Yes">
                    Agri output
                  </Label>
                </div>
              </div>
            </Col>
          ) : (
            //  <Col lg="3" className="mb-2">
            //   <Label>Experience in:</Label>
            //   <CustomTextField
            //     type="text"
            //     name=""
            //      defaultValue={SaathiUserData?.business_details?.experience_in_insurance === true ? "Yes" : "No"  }

            //     disabled
            //   />
            // </Col>
            ""
          )}

          {isEdit === true ? (
            ""
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Is sold Insurance and Bank Product ?</Label>
              <CustomTextField
                type="text"
                name=""
                defaultValue={
                  SaathiUserData?.business_details
                    ?.is_sold_insurance_and_bank_product === true
                    ? "Yes"
                    : "No" || "Select"
                }
                placeholder="Select.."
                disabled
              />
            </Col>
          )}
          {isEdit === true ? (
            <Col lg="4" className="mb-2">
              <Label>
                Is professional training insurance and bank product ?
              </Label>
              <Select
                value={
                  professionaltraining === undefined
                    ? professionaltraining
                    : professionaltraining.label
                }
                onChange={(professionaltraining) => {
                  handelprofessionaltraining(professionaltraining.value);
                }}
                options={PlicyData}
                styles={customStyles}
                placeholder={
                  SaathiUserData?.business_details
                    ?.is_professional_training_insurance_and_bank_product ===
                  true
                    ? "Yes"
                    : "No"
                }
              />
            </Col>
          ) : (
            <Col lg="4" className="mb-2">
              <Label>
                Is professional training insurance and bank product ?
              </Label>
              <CustomTextField
                type="text"
                name=""
                defaultValue={
                  SaathiUserData?.business_details
                    ?.is_professional_training_insurance_and_bank_product ===
                  true
                    ? "Yes"
                    : "No" || "Select..."
                }
                disabled
                placeholder="Select ..."
              />
            </Col>
          )}
          {isEdit === true ? (
            <Col lg={5} className="mb-2">
              <Label>Interested in : </Label>
              <div className="col-lg-12 p-0 d-flex">
                <div className="form-check form-check-inline ps-0">
                  <input
                    onChange={onInputChange}
                    name="interest_in_selling"
                    type="radio"
                    value="InsuranceProducts"
                    checked={
                      SaathiData.interest_in_selling == "InsuranceProducts"
                    }
                    readOnly
                  />
                  <Label htmlFor="InsuranceProducts" className="ms-2 mb-0">
                    Insurance Products
                  </Label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={onInputChange}
                    name="interest_in_selling"
                    type="radio"
                    value="BankingProducts"
                    checked={
                      SaathiData.interest_in_selling === "BankingProducts"
                    }
                    readOnly
                  />
                  <Label htmlFor="BankingProducts" className="ms-2 mb-0">
                    Banking Products
                  </Label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={onInputChange}
                    name="interest_in_selling"
                    type="radio"
                    value="Both"
                    checked={SaathiData.interest_in_selling === "Both"}
                    readOnly
                  />
                  <Label
                    htmlFor="Both"
                    name="interest_in_selling"
                    value="both"
                    className="ms-2 mb-0"
                    onChange={onInputChange}
                  >
                    Both
                  </Label>
                </div>
              </div>
            </Col>
          ) : (
            <Col lg="2" className="mb-2">
              <Label>Interest in Selling </Label>
              <CustomTextField
                type="text"
                name=""
                defaultValue={
                  SaathiUserData?.business_details?.interest_in_selling
                }
                disabled
              />
            </Col>
          )}
          {isEdit === true ? (
            <Col lg={12} className="text-center m-auto pb-5 mt-5">
              <button
                type="submit"
                className="btn btn-success text-white p-3 ms-3"
              >
                <span class="mdi mdi-content-save "></span> Update Business
                Details &nbsp;
                {loader ? <Spinner animation="border" size="sm"></Spinner> : ""}
              </button>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </form>
    </Row>
  );
};

export default SaathiBusinessDetails;
